module.exports = __webpack_public_path__ + "img/keyboard.966f460c.jpg";